import { fromJS, List } from 'immutable';
import { normalizeItems, findByIdFromIdsCollectionFn } from '@Utils';

import {
  saveAlertsType,
  removeAlertActionType,
  alertDeleteStartType,
  alertDeleteFailedType,
  handleViewDeleteModalType,
  setRefetchType,
  setMountedType,
} from './AlertsConstants';

export const initialState = fromJS({
  refetch: false,
  showDeleteModal: false,
  alertIdToDelete: null,
  isDeleteInProgress: false,
  deletingAlertId: null,
});

function buildGroupIds(ids = List(), items = fromJS({})) {
  // Preserve the fetched group order so deleting a group's first alert does not reshuffle remaining groups.
  return ids.reduce((groupIds, id) => {
    const groupId = items.getIn([id, 'alertsItem', 'groupId']);

    return groupIds.includes(groupId) ? groupIds : groupIds.push(groupId);
  }, List());
}

function removeEmptyGroupIds(groupIds, ids, items) {
  return groupIds.filter((groupId) => ids.some((id) => items.getIn([id, 'alertsItem', 'groupId']) === groupId));
}

export default function alertsReducer(state, action) {
  const currentState = state ?? initialState;

  switch (action.type) {
    case saveAlertsType: {
      const { alerts } = action.payload;
      const { items, ids } = normalizeItems(alerts);
      const nextState = currentState.set('items', fromJS(items)).set('ids', fromJS(ids));

      return nextState.set('groupIds', buildGroupIds(nextState.get('ids'), nextState.get('items')));
    }

    case alertDeleteStartType: {
      const { id } = action.payload;
      const nextState = currentState.set('isDeleteInProgress', true);

      return nextState.set('deletingAlertId', id);
    }

    case alertDeleteFailedType:
      return currentState.set('isDeleteInProgress', false).set('deletingAlertId', null);

    case handleViewDeleteModalType: {
      const { show, id } = action.payload;
      const nextState = currentState.set('showDeleteModal', show);

      return nextState.set('alertIdToDelete', id);
    }

    case removeAlertActionType: {
      const { id } = action.payload;
      const findFn = findByIdFromIdsCollectionFn(id);
      const stateWithUpdatedIds = currentState.update('ids', (ids) => {
        const requiredIdIndex = ids.findIndex(findFn);

        return ids.delete(requiredIdIndex);
      });
      const stateWithoutDeletedItem = stateWithUpdatedIds.deleteIn(['items', id]);
      const previousGroupIds = currentState.get('groupIds') || buildGroupIds(currentState.get('ids'), currentState.get('items'));
      const stateWithUpdatedGroupIds = stateWithoutDeletedItem.set(
        'groupIds',
        removeEmptyGroupIds(previousGroupIds, stateWithoutDeletedItem.get('ids'), stateWithoutDeletedItem.get('items'))
      );
      const stateWithClosedModal = stateWithUpdatedGroupIds.set('showDeleteModal', false);
      const stateWithClearedModalAlert = stateWithClosedModal.set('alertIdToDelete', null);
      const stateWithDeleteDone = stateWithClearedModalAlert.set('isDeleteInProgress', false);

      return stateWithDeleteDone.set('deletingAlertId', null);
    }

    case setMountedType: {
      const { mounted } = action.payload;
      return currentState.set('mounted', mounted);
    }

    case setRefetchType: {
      const { refetch } = action.payload;
      return currentState.set('refetch', refetch);
    }

    default: {
      return currentState;
    }
  }
}
